import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, type Firestore } from 'firebase/firestore';

let cached: { app: FirebaseApp; auth: Auth; db: Firestore } | null = null;

export function firebase() {
  if (cached) return cached;
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  };
  const app = initializeApp(config);
  const auth = getAuth(app);
  // Target a named Firestore database if VITE_FIRESTORE_DATABASE_ID is set;
  // otherwise the (default) DB. Used to isolate local dev from prod.
  const databaseId = import.meta.env.VITE_FIRESTORE_DATABASE_ID;
  const db = databaseId ? getFirestore(app, databaseId) : getFirestore(app);

  if (import.meta.env.VITE_USE_EMULATORS === 'true') {
    const authHost = import.meta.env.VITE_AUTH_EMULATOR_HOST || 'http://localhost:9099';
    connectAuthEmulator(auth, authHost, { disableWarnings: true });
    const fsHost = import.meta.env.VITE_FIRESTORE_EMULATOR_HOST || 'localhost:8081';
    const [host, port] = fsHost.split(':');
    if (host && port) connectFirestoreEmulator(db, host, Number(port));
  }

  cached = { app, auth, db };
  return cached;
}
